<template>
    <div>
      <v-container container--fluid grid-list-xl>
         <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="d-inline-flex justify-space-between">
            <v-switch
              style="align-items: center"
              color="blue"
              v-model="activeOnlySwitch"
              :label="activeOnlySwitch ? 'Active Only' : 'Show All'"
            ></v-switch>
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newUser" v-on="on">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Create a new driver</span>
                </v-tooltip>
          </v-col>
         </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :search="search"
        :loading="loading"
        :items="renderedUsers"
        :items-per-page="-1"
        >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}" @click="editRow(props.item)">
            <td style="text-align: center" v-for="(header, index) in headers" :key="index"
                v-if="!['actions', 'active'].find((s) => {return s === header.value})">{{props.item[header.value]}}
            </td>
            <td v-else-if="header.value === 'active'" style="text-align: center">{{props.item.active ? 'Active' : 'Disabled'}}
            </td>
            <td v-else style="text-align: center">
              <v-btn icon @click="editRow(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn icon @click="deleteRow(props.item)">
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog
        v-model="deleteDialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title class="justify-center">
            <h3>ATTENTION</h3>
          </v-card-title>
          <v-card-text class="text-center">
            You are about to delete this users.<br>
            This action cannot be undone. <br>
            Are you sure you want to proceed ?
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
            <v-btn text color="blue darken-1" @click="deleteUser">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <EditContractorUser
        v-if="user"
        :user="user"
        :regionDepots="regionDepots"
        :editDialog="editDialog"
        ref="editComponent"
        @close="closeEditDialog"
        @save="saveChanges"
      ></EditContractorUser>
    </div>
</template>

<script>
  import axios from 'axios';
  import EditContractorUser from './EditContractorUser';

    export default {
      name: "ContractorUsersDataTable",
      props: {
        contractor: Object,
        regionDepots: Array,
      },
      components: {
        EditContractorUser
      },
      data() {
        return {
          search: '',
          loading: false,
          toBeDeleted: null,
          deleteDialog: false,
          editDialog: false,
          user: null,
          activeOnlySwitch: true,
          reload: false,
          default: {
            id: 0,
            name: null,
            is_driver: true,
            is_scanner: false,
            scanner_level: 0,
            active: true,
          }
        }
      },
      computed: {
        renderedUsers() {
          if (this.users === null || this.users === undefined) return [];
          if (this.activeOnlySwitch) {
            return this.users.filter((user) => {
              return user.active;
            })
          } else {
            return this.users;
          }
        },
        editPermission() {
          return this.$store.getters['auth/hasPermission']('contractors_edit');
        },
        headers() {
          let headers = [
            {text: 'Id', value: 'id', align: 'center', sortable: true},
            {text: 'Name', value: 'name', align: 'center', sortable: true},
            {text: 'PIN', value: 'pin', align: 'center', sortable: true},
            {text: 'Created', value: 'created', align: 'center', sortable: false},
            {text: 'Last Edit', value: 'last_edit', align: 'center', sortable: false},
            {text: 'Status', value: 'active', align: 'center', sortable: false},
          ];
          if (this.editPermission) headers.push({text: 'Actions', value: 'actions', align: 'center', sortable: false});
          return headers;
        }
      },
      asyncComputed: {
        async users() {
          if (this.reload || !this.reload) {
            if (this.contractor === null || this.contractor.id === 0) {
              this.reload = false;
              return [];
            }
            this.loading = true;
            return await axios.get(process.env.API_URL + '/contractors/' + this.contractor.id + '/users')
              .then((response) => {
                if (response.status === 200) {
                  this.loading = false;
                  this.reload = false;
                  return response.data;
                } else {
                  this.loading = false;
                  this.reload = false;
                  return [];
                }
              })
              .catch((error) => {
                this.loading = false;
                this.reload = false;
                return [];
              })
          }
        }
      },
      methods: {
        newUser() {
          this.user = Object.assign({}, this.default);
          this.editDialog = true;
        },
        editRow(item) {
          this.user = Object.assign({}, item);
          this.editDialog = true;
        },
        deleteRow(item) {
          this.toBeDeleted = item;
          this.deleteDialog = true;
          this.closeEditDialog();
        },
        deleteUser() {
          axios.delete(process.env.API_URL + '/contractors/' + this.contractor.id + '/users/' + this.toBeDeleted.id)
            .then((response) => {
              this.toBeDeleted = null;
              this.deleteDialog = false;
              this.reload = true;
                this.$store.commit('displaySnackbar', 'Delete successful');
            })
            .catch ((error) => {
              if (error.response !== undefined) {
                  this.$store.commit('displaySnackbar', 'ERROR: ' + error.response.data.error);
              } else {
                  this.$store.commit('displaySnackbar',  'ERROR: Delete failed');
              }
            });
        },
        toggleDeleteDialog(item) {
          this.toBeDeleted = item;
          this.deleteDialog = true;
        },
        closeEditDialog() {
          this.editDialog = false;
          this.user = null;
        },
        saveChanges() {
          if (!this.user.is_scanner) this.user.scanner_level = 0;
          if (this.user.id > 0) {
            axios.put(process.env.API_URL + '/contractors/' + this.contractor.id + '/users/' + this.user.id, this.user)
              .then((response) => {
                this.editDialog = false;
                this.user = null;
                this.reload = true;
                  this.$store.commit('displaySnackbar', 'Save successful');
              })
              .catch((error) => {
                if (error.response !== undefined) {
                    this.$store.commit('displaySnackbar', 'ERROR: ' + error.response.data.error);
                } else {
                    this.$store.commit('displaySnackbar', 'ERROR: Save failed');
                }
              });
          } else {
            axios.post(process.env.API_URL + '/contractors/' + this.contractor.id + '/users', this.user)
              .then((response) => {
                this.editDialog = false;
                this.user = null;
                this.reload = true;
                  this.$store.commit('displaySnackbar', 'Create successful');
              })
              .catch((error) => {
                if (error.response !== undefined) {
                    this.$store.commit('displaySnackbar', 'ERROR: ' + error.response.data.error);
                } else {
                    this.$store.commit('displaySnackbar', 'ERROR: Create failed');
                }
              });
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Contractors/ContractorUsersDataTable.vue